<template>
  <div id="xzt">
    <div class="header">
      <el-button type="primary" @click="onBafa">八方</el-button>
      <div class="header-left">
        <span> 当前用户:{{ this.user.username }}</span>
        <el-button class="user-logout" type="danger" icon="el-icon-switch-button" size="mini" @click="onLogout">退出</el-button>
        <span v-if="lookUser"> 查看用户:{{ this.lookUser.username }}</span>
        <span> 年份:{{ currentYear }} </span>
        <span> 总注数:{{ totalPrice }} </span>
        <span> 抄底平均值(倍数:{{ average }}): {{ averagePrice }} </span>
        <!-- <span> 最大值:{{ maxPrice }} </span> -->
        <!-- <span> 最小值:{{ minPrice }} </span> -->
        <!-- <span> 总下注次数:{{ totalCount }} </span> -->
      </div>
      <div class="header-right">
        <el-button type="danger" @click="onClearAll" v-show="showAdmin">总清除</el-button>
        <el-button type="danger" @click="onClear">清除</el-button>
        <el-button type="primary" @click="onAll" v-show="showAdmin">总结算</el-button>
        <el-button type="primary" @click="onSettlement">结算</el-button>
        <el-button type="primary" @click="onStatics">统计</el-button>
        <el-button type="primary" @click="addUser" v-show="showAdmin">帐号列表</el-button>
      </div>
    </div>
    <div class="content clearfix">
      <div class="content-left">
        <div class="nums">
          <div class="nums-title">特码A</div>
          <div class="nums-rows clearfix">
            <div class="num-row" v-for="(nnitem, nindex) in nums">
              <template v-for="(nitem, index) in nnitem">
                <div :class="nitem.selected == true ? 'nums-item active' : 'nums-item'
                  " @click="onSelectItem(index, nindex)">
                  <p :class="`${nitem.color}`">{{ nitem.title }}</p>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="sxs clearfix">
          <template v-for="(sitem, index) in sx">
            <div :class="sitem.selected == true ? 'sxs-item active' : 'sxs-item'" @click="onSXitem(index)">
              {{ sitem.name }}
            </div>
          </template>
        </div>
        <div class="others clearfix">
          <template v-for="(oitem, oindex) in other">
            <div :class="ooindex == oindex ? 'other active' : `other ${oitem.color}`" @click="onOther(oindex)">{{
              oitem.value }}
            </div>
          </template>
        </div>
        <div class="tools">
          <span>金额:</span>
          <el-input placeholder="" v-model="sx_money"></el-input>
          <el-button type="primary" @click="onBuysx">确定</el-button>
          <el-button type="warning" @click="onClearsx">清空</el-button>
        </div>
        <div class="nums-bottom">
          <template v-for="(iitem, iindex) in moneys">
            <div :class="nindex == iindex ? 'num active' : 'num'" @click="onNum(iindex, iitem)">{{ iitem }}</div>
          </template>
        </div>
      </div>
      <div class="sx-content">
        <div class="title">平肖</div>
        <template v-for="(item, index) in sx">
          <div class="sx-item" :key="index">
            <s-item :item="item" :index="index" @buy="onItemBuy" />
          </div>
        </template>
      </div>
      <div class="ws-content">
        <div class="title">尾数</div>
        <template v-for="(item, index) in ws">
          <div class="ws-item" :key="index">
            <s-item :item="item" :index="index" @buy="onItemBuyTwo" />
          </div>
        </template>
      </div>
      <div class="sx-content-new">
        <div class="title">生肖</div>
        <template v-for="(item, index) in sx">
          <div class="item" :key="index" v-if="item.values">
            <div class="title">{{ item.name }}</div>
            <div class="content-new"><template v-for="iitem in item.values">
                <label>{{ iitem }}</label>
              </template>
            </div>
          </div>
        </template>
      </div>
      <div class="ai-content">
        <textarea ref="aiTxtInput" name="aiTxt" id="aiTxt" cols="30" rows="10" v-model="aiTxt"></textarea>
        <div class="btns">
          <el-button type="warning" @click="onClearAiParse">清除</el-button>
          <el-button type="primary" @click="onParse">检测</el-button>
          <el-button type="success" @click="onSubmitParse" :disabled="!aiParsed">提交</el-button>
        </div>
        <div class="aiResult">
          <div class="summary" v-if="aiParsed">
            <p>号码：{{ aiParsed.numbers.length }} 项，合计 {{ aiParsed.total }}</p>
            <p v-if="aiParsed.sxBets.length">平肖：{{ aiParsed.sxBets.length }} 项，合计 {{ aiParsed.sxTotal }}</p>
            <p v-if="aiParsed.wsBets.length">尾平：{{ aiParsed.wsBets.length }} 项，合计 {{ aiParsed.wsTotal }}</p>
            <p v-if="aiParsed.markets.length">线路：{{ aiParsed.markets.join('、') }}</p>
            <p v-if="aiParsed.unmatched.length">未识别：{{ aiParsed.unmatched.length }} 行</p>
          </div>
          <div class="preview sx-preview" v-if="aiWsResult.length">
            <span class="tag" v-for="(item,index) in aiWsResult" :key="index">
              <button class="remove" @click="onRemoveAiWsResult(index)">×</button>
              <span class="sx-name">{{ item.name }}</span>
              <span class="count">{{ item.count }}</span>
              <span class="market" v-if="item.market">{{ item.market }}</span>
            </span>
          </div>
          <div class="preview sx-preview" v-if="aiSxResult.length">
            <span class="tag" v-for="(item,index) in aiSxResult" :key="index">
              <button class="remove" @click="onRemoveAiSxResult(index)">×</button>
              <span class="sx-name">{{ item.name }}</span>
              <span class="count">{{ item.count }}</span>
              <span class="market" v-if="item.market">{{ item.market }}</span>
            </span>
          </div>
          <div class="preview" v-if="aiResult.length">
            <span class="tag" v-for="(item,index) in aiResult" :key="index">
              <button class="remove" @click="onRemoveAiResult(index)">×</button>
              <span class="sx-name">{{ item.sx }}</span>
              <span class="num">{{ item.num }}</span>
              <span class="count">{{ item.count }}</span>
              <span class="market" v-if="item.market">{{ item.market }}</span>
            </span>
          </div>
          <div class="unmatched" v-if="aiParsed && aiParsed.unmatched.length">
            <p v-for="(item,index) in aiParsed.unmatched" :key="index">{{ item }}</p>
          </div>
          <div class="history" v-if="aiSubmitHistory.length">
            <div class="history-title">
              <span>提交记录</span>
              <el-button type="warning" size="mini" @click="onClearAiSubmitHistory">清空记录</el-button>
            </div>
            <div class="item history-item" v-for="(item,index) in aiSubmitHistory" :key="item.id">
              <div class="history-info">
                <p>{{ item.time }}：号码 {{ item.numbers.length }} 项，平肖 {{ item.sxBets ? item.sxBets.length : 0 }} 项，尾平 {{ item.wsBets ? item.wsBets.length : 0 }} 项，合计 {{ item.total }}</p>
                <pre v-if="item.txt || item.text">{{ item.txt || item.text }}</pre>
              </div>
              <el-button type="danger" @click="onUndoParse(index)">撤销</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer"></div>
    <x-list ref="x-list"></x-list>
    <s-list ref="s-list"></s-list>
    <add-user ref="addUser"></add-user>
    <user-list ref="userList" @sucess="onSelectUser" @look="onLookUser"></user-list>
  </div>
</template>
<script>
import { getNumbers, getMoney, getTotals, getSxListByYear, getNumberSxName } from "./num.js";
import { getLocalUser, removeToken, removeLocalUser } from "../../config/cache.js";
import { setAppTitle } from "../../config/appTitle";
import ItemNumber from "./item.vue";
import SItem from "./sxitem.vue";
import xList from "./list.vue";
import sList from "./slist.vue";
import addUser from "./adduser.vue"
import userList from "./userlist.vue"
const arr = [1, 0, 'red', 'blue', 'green', 2, 3, 4, 5];
const AI_HISTORY_KEY = "xzt_ai_submit_history";
const AI_BATCH_SUBMIT_API = "/admin/xzt/batch";
const AI_BATCH_UNDO_API = "/admin/xzt/batchUndo";
const USE_AI_BATCH_API = false;
export default {
  components: { ItemNumber, xList, addUser, userList, sList, SItem },
  data() {
    return {
      aiTxt: "",
      aiResult:[],
      aiSxResult: [],
      aiWsResult: [],
      aiParsed: null,
      aiSubmitHistory: [],
      isElectron: false,
      electronClipboardCleanup: null,
      nums: [],
      nindex: -1,
      selectedSX: -1,
      totalPrice: 0,
      totalCount: 0,
      maxPrice: 0,
      minPrice: 0,
      averagePrice: 0, //平均
      average: 45, //42倍 倍数
      buyPrice: 0, //可买
      sx_money: "",
      showAdmin: false, 
      currentYear: new Date().getFullYear(),
      currentYearFromLogin: false,
      user: null,
      lookUser: null,
      moneys: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 60, 70, 80, 90, 100, 200, 300, 400, 500, 1000],
      other: [
        {
          value: "单",
          color: 'black'
        },
        {
          value: "双",
          color: 'black'
        },
        {
          value: "红 波",
          color: 'red'
        },
        {
          value: "蓝 波",
          color: 'blue'
        },
        {
          value: "绿 波",
          color: 'green'
        },
        {
          value: "大",
          color: 'black'
        },
        {
          value: "小",
          color: 'black'
        },
        {
          value: "家 禽",
          color: 'black'
        },
        {
          value: "野 兽",
          color: 'black'
        },
      ],
      ooindex: -1,
      sx: [

      ],
      ws: [
        { name: "0尾", value: 0 },
        { name: "1尾", value: 0 },
        { name: "2尾", value: 0 },
        { name: "3尾", value: 0 },
        { name: "4尾", value: 0 },
        { name: "5尾", value: 0 },
        { name: "6尾", value: 0 },
        { name: "7尾", value: 0 },
        { name: "8尾", value: 0 },
        { name: "9尾", value: 0 }]
    };
  },
  created() {

    this.user = getLocalUser() || {};
    const loginYear = this.getUserCurrentYear(this.user);
    if (loginYear) {
      this.currentYear = loginYear;
      this.currentYearFromLogin = true;
    }

    console.log("userinfo:", this.user);
    // var query = this.$route.query
    if (this.user.username != undefined) {
      this.showAdmin = (this.user.username == "admin" ? true : false);
    }
    this.loadAiSubmitHistory();
    this.init();
  },
  mounted() {
    this.isElectron = !!(window.xztElectron && window.xztElectron.onClipboardText);
    if (this.isElectron) {
      this.electronClipboardCleanup = window.xztElectron.onClipboardText(payload => {
        const text = payload && payload.text !== undefined ? payload.text : payload;
        const source = payload && payload.source ? payload.source : "manual";
        if (source === "watch") {
          this.appendWatchedAiText(text);
        } else {
          this.insertAiText(text);
          this.$message.success("已粘贴到检测框");
        }
      });
    }
  },
  beforeDestroy() {
    if (this.electronClipboardCleanup) {
      this.electronClipboardCleanup();
      this.electronClipboardCleanup = null;
    }
  },
  methods: {
    onLogout() {
      removeToken("");
      removeLocalUser("");
      setAppTitle(null);
      this.$router.push("/login");
    },
    getUserCurrentYear(user) {
      const value = user && (user.currentYear || user.current_year || user.lunarYear || user.lunar_year || user.year);
      const year = parseInt(value);
      return year > 0 ? year : 0;
    },
    focusAiTextEnd() {
      this.$nextTick(() => {
        const textarea = this.$refs.aiTxtInput;
        if (!textarea) return;
        const cursor = this.aiTxt.length;
        textarea.focus();
        textarea.setSelectionRange(cursor, cursor);
      });
    },
    setAiText(text) {
      const value = String(text || "");
      if (!value) return;
      this.aiTxt = value;
      this.focusAiTextEnd();
    },
    appendWatchedAiText(text) {
      const value = String(text || "").trim();
      if (!value) return;
      const separator = "-----";
      this.aiTxt = this.aiTxt.trim()
        ? `${this.aiTxt.trimEnd()}\n\n${separator}\n${value}`
        : value;
      this.focusAiTextEnd();
    },
    insertAiText(text) {
      const value = String(text || "");
      if (!value) return;
      const textarea = this.$refs.aiTxtInput;
      if (!textarea || typeof textarea.selectionStart !== "number") {
        this.aiTxt = this.aiTxt ? `${this.aiTxt}\n${value}` : value;
        return;
      }
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      this.aiTxt = `${this.aiTxt.slice(0, start)}${value}${this.aiTxt.slice(end)}`;
      this.$nextTick(() => {
        const cursor = start + value.length;
        textarea.focus();
        textarea.setSelectionRange(cursor, cursor);
      });
    },
    onClearAiParse() {
      this.aiTxt = "";
      this.aiResult = [];
      this.aiSxResult = [];
      this.aiWsResult = [];
      this.aiParsed = null;
      this.$nextTick(() => {
        if (this.$refs.aiTxtInput) this.$refs.aiTxtInput.focus();
      });
    },
    onPasteElectronClipboard() {
      if (!window.xztElectron || !window.xztElectron.readClipboardText) return;
      window.xztElectron.readClipboardText().then(text => {
        this.insertAiText(text);
      });
    },
    onParse() {
      const text = this.aiTxt.trim();
      if (!text) {
        this.aiResult = [];
        this.aiSxResult = [];
        this.aiWsResult = [];
        this.aiParsed = null;
        return;
      }
      let parsed = this.parseText(text);
      this.aiParsed = parsed;
      this.aiResult = parsed.numbers;
      this.aiSxResult = parsed.sxBets;
      this.aiWsResult = parsed.wsBets;
      console.log("parsed:", parsed);
    },
    parseText(text) {
      const numberMap = {};
      const sxBetMap = {};
      const wsBetMap = {};
      const unmatched = [];
      const markets = [];
      const amountText = "(?:[零一二两三四五六七八九十百千万佰]+|\\d+(?:\\.\\d+)?)";
      const animalNames = this.sx.map(item => item.name).join("");
      const listSep = "[,\\.\\\\=+\\-*\\/#@]";
      const numListText = "[\\d,\\.\\\\=+\\-*\\/#@\\s]+";
      const animalListText = `[${animalNames}](?:${listSep}+[${animalNames}])*`;
      const tailText = "[0-9零一二两三四五六七八九]";
      const tailSep = "[,\\.\\\\=+\\-*\\/#@\\s]";
      const tailListWithTailText = `(?:${tailText}(?:尾)?(?:${tailSep}*)?)*${tailText}尾(?:${tailSep}*)?`;

      const normalize = value => {
        return value
          .replace(/[０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 65248))
          .replace(/[，、；;]/g, ",")
          .replace(/[。]/g, ".")
          .replace(/[＝]/g, "=")
          .replace(/[／]/g, "/")
          .replace(/[（]/g, "(")
          .replace(/[）]/g, ")")
          .replace(/水/g, "鼠")
          .replace(/免/g, "兔")
          .replace(/\r/g, "");
      };
      const getMarket = value => {
        if (/澳门|澳|奥/.test(value)) return "澳门";
        if (/香港|港/.test(value)) return "香港";
        return "";
      };
      const cnNum = value => {
        let str = String(value || "")
          .replace(/[斤米元#闷号数]/g, "")
          .replace(/块|蚊|圆|個|个/g, "")
          .replace(/佰/g, "百")
          .trim()
          .replace(/^\\.+|\\.+$/g, "");
        if (/^\d+(?:\\.\\d+)?$/.test(str)) return Number(str);
        const map = {
          零: 0,
          一: 1,
          二: 2,
          两: 2,
          三: 3,
          四: 4,
          五: 5,
          六: 6,
          七: 7,
          八: 8,
          九: 9
        };
        let total = 0;
        let section = 0;
        let number = 0;
        const units = { 十: 10, 百: 100, 千: 1000, 万: 10000 };
        for (let i = 0; i < str.length; i++) {
          const char = str[i];
          if (map[char] !== undefined) {
            number = map[char];
          } else if (units[char]) {
            const unit = units[char];
            if (unit === 10000) {
              section = (section + number) * unit;
              total += section;
              section = 0;
            } else {
              section += (number || 1) * unit;
            }
            number = 0;
          }
        }
        return total + section + number;
      };
      const validNum = value => {
        const num = parseInt(value, 10);
        return num >= 1 && num <= 49;
      };
      const addNum = (num, count, market) => {
        const value = Number(count);
        if (!validNum(num) || !value) return;
        const key = String(parseInt(num, 10)).padStart(2, "0");
        numberMap[key] = numberMap[key] || { num: key, count: 0, market: market || "" };
        numberMap[key].count += value;
        if (market && numberMap[key].market.indexOf(market) === -1) {
          numberMap[key].market = numberMap[key].market ? `${numberMap[key].market}、${market}` : market;
        }
      };
      const numsFromText = value => {
        const matches = String(value).match(/\d{1,2}/g) || [];
        return matches.filter(validNum);
      };
      const animalsFromText = value => {
        return String(value)
          .split(new RegExp(`${listSep}+`))
          .filter(Boolean)
          .reduce((names, item) => names.concat(item.split("")), [])
          .filter(name => animalNames.indexOf(name) !== -1);
      };
      const normalizeAnimalListBeforeMarker = value => {
        return String(value).replace(
          new RegExp(`(${animalListText})${listSep}*(?=(?:特)?(?:各包|包|各肖|各号|各数|各)${amountText})`, "g"),
          namesText => animalsFromText(namesText).join("")
        );
      };
      const addNums = (nums, count, market) => {
        nums.forEach(num => addNum(num, count, market));
      };
      const addSxBet = (name, count, market) => {
        const sxIndex = this.sx.findIndex(item => item.name === name);
        const value = Number(count);
        if (sxIndex === -1 || !value) return;
        sxBetMap[name] = sxBetMap[name] || {
          name,
          count: 0,
          index: sxIndex,
          market: market || ""
        };
        sxBetMap[name].count += value;
        if (market && sxBetMap[name].market.indexOf(market) === -1) {
          sxBetMap[name].market = sxBetMap[name].market ? `${sxBetMap[name].market}、${market}` : market;
        }
      };
      const addWsBet = (tail, count, market) => {
        const value = Number(count);
        const tailNum = cnNum(tail);
        if (tailNum < 0 || tailNum > 9 || !value) return;
        const key = `${tailNum}尾`;
        wsBetMap[key] = wsBetMap[key] || {
          name: key,
          tail: tailNum,
          count: 0,
          market: market || ""
        };
        wsBetMap[key].count += value;
        if (market && wsBetMap[key].market.indexOf(market) === -1) {
          wsBetMap[key].market = wsBetMap[key].market ? `${wsBetMap[key].market}、${market}` : market;
        }
      };
      const addAnimalBet = (name, amount, marker, market) => {
        const nums = getAnimalNumbers(name);
        if (!nums.length) return;
        const money = cnNum(amount);
        const value = marker && marker !== "各肖" && marker !== "各包" && marker !== "包" ? money : Math.floor(money / nums.length);
        addNums(nums, value, market);
      };
      const addAnimalSplitBet = (name, amount, market) => {
        const nums = getAnimalNumbers(name);
        if (!nums.length) return;
        const money = cnNum(amount);
        addNums(nums, money / nums.length, market);
      };
      const getAnimalNumbers = name => {
        const item = this.sx.find(sitem => sitem.name === name);
        return item && item.values ? item.values : [];
      };
      const getAnimalGroupItems = name => {
        const isWild = name.indexOf("野") !== -1;
        const isHouse = name.indexOf("家") !== -1 || name.indexOf("禽") !== -1;
        if (!isWild && !isHouse) return [];
        return this.sx.filter(item => (isWild && item.isjq === false) || (isHouse && item.isjq === true));
      };
      const getAnimalGroupNumbers = name => {
        return getAnimalGroupItems(name).reduce((nums, item) => nums.concat(item.values || []), []);
      };
      const getTailNumbers = tail => {
        const value = cnNum(tail);
        const nums = [];
        for (let i = 1; i < 50; i++) {
          if (i % 10 === value) nums.push(i);
        }
        return nums;
      };
      const tailsFromText = value => {
        return (String(value).match(new RegExp(tailText, "g")) || []).filter(tail => {
          const tailNum = cnNum(tail);
          return tailNum >= 0 && tailNum <= 9;
        });
      };
      const headsFromText = value => {
        return String(value).match(/[0-9]/g) || [];
      };
      const getHeadNumbers = head => {
        const value = parseInt(head, 10);
        const nums = [];
        for (let i = 1; i < 50; i++) {
          if (Math.floor(i / 10) === value) nums.push(i);
        }
        return nums;
      };
      const getOtherNumbers = (name, prefix) => {
        name = name.replace(/波|数/g, "");
        let nums = [];
        if (name.indexOf("单") !== -1) nums = nums.length ? nums.filter(i => i % 2 === 1) : Array.from({ length: 49 }, (_, i) => i + 1).filter(i => i % 2 === 1);
        if (name.indexOf("双") !== -1) nums = nums.length ? nums.filter(i => i % 2 === 0) : Array.from({ length: 49 }, (_, i) => i + 1).filter(i => i % 2 === 0);
        if (name.indexOf("大") !== -1) nums = nums.length ? nums.filter(i => i > 24) : Array.from({ length: 25 }, (_, i) => i + 25);
        if (name.indexOf("小") !== -1) nums = nums.length ? nums.filter(i => i < 25) : Array.from({ length: 24 }, (_, i) => i + 1);
        const colors = {
          红: [1, 2, 7, 8, 12, 13, 18, 19, 23, 24, 29, 30, 34, 35, 40, 45, 46],
          蓝: [3, 4, 9, 10, 14, 15, 20, 25, 26, 31, 36, 37, 41, 42, 47, 48],
          兰: [3, 4, 9, 10, 14, 15, 20, 25, 26, 31, 36, 37, 41, 42, 47, 48],
          绿: [5, 6, 11, 16, 17, 21, 22, 27, 28, 32, 33, 38, 39, 43, 44, 49]
        };
        Object.keys(colors).forEach(color => {
          if (name.indexOf(color) !== -1) {
            nums = nums.length ? nums.filter(i => colors[color].indexOf(i) !== -1) : colors[color];
          }
        });
        if (prefix === "特" && nums.length === 0) nums = Array.from({ length: 49 }, (_, i) => i + 1);
        return nums;
      };
      const addOtherBet = (name, amount, marker, market) => {
        const cleanName = name.replace(/波|数/g, "");
        const nums = getOtherNumbers(cleanName, cleanName.indexOf("特") !== -1 ? "特" : "");
        if (!nums.length) return false;
        const money = cnNum(amount);
        const value = marker === "包" ? Math.floor(money / nums.length) : money;
        addNums(nums, value, market);
        return true;
      };

      text = normalize(text);
      text.split("\n").forEach(rawLine => {
        const line = rawLine.trim();
        if (!line || /^[-=]{3,}$/.test(line) || /^(多线路|生肖|标准格式|非标准格式|识别|下面生肖|你只需|一条单子|总结|以下)/.test(line)) return;
        const market = getMarket(line);
        if (market && markets.indexOf(market) === -1) markets.push(market);
        let rest = line
          .replace(/澳门|香港|澳|奥|港/g, "")
          .replace(/(\d)\s+(?=\d)/g, "$1,")
          .replace(/\s+/g, "");
        rest = normalizeAnimalListBeforeMarker(rest);
        let matched = false;

        rest = rest.replace(new RegExp(`(\\d{1,2})[-#+](\\d{2,})(?=,|\\.|\\+|#|\\*|-|各|$)`, "g"), (_, num, amount) => {
          if (validNum(num) && Number(amount) > 49) {
            addNum(num, cnNum(amount), market);
            matched = true;
            return ",";
          }
          return _;
        });
        rest = rest.replace(new RegExp(`平(${animalListText}|[${animalNames}]+)${listSep}*(?:各包|各肖|各数|各)?(${amountText})(?=,|$)`, "g"), (_, namesText, amount) => {
          animalsFromText(namesText).forEach(name => addSxBet(name, cnNum(amount), market));
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`((?:[${animalNames}]平${listSep}*)+)(?:各包|各肖|各数|各)?(${amountText})(?=,|$)`, "g"), (_, namesText, amount) => {
          animalsFromText(namesText.replace(/平/g, "")).forEach(name => addSxBet(name, cnNum(amount), market));
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`(${animalListText}|[${animalNames}]+)${listSep}*(?:各号|各数)(${amountText})(?=,|$)`, "g"), (_, namesText, amount) => {
          animalsFromText(namesText).forEach(name => addAnimalBet(name, amount, "各", market));
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`(${animalListText}|[${animalNames}]+)${listSep}*(?:各包|各肖|各)(${amountText})(?=,|$)`, "g"), (_, namesText, amount) => {
          animalsFromText(namesText).forEach(name => addAnimalBet(name, amount, "各肖", market));
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`平${tailSep}*(${tailListWithTailText})(?:各|各号|各数|每个数|每号|一个数)?(${amountText})`, "g"), (_, tailsText, amount) => {
          tailsFromText(tailsText).forEach(tail => addWsBet(tail, cnNum(amount), market));
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`(?:特${tailSep}*)?((?:${tailText}${tailSep}*)+)尾${tailSep}*(?:各|各号|各数|每个数|每号|一个数)(${amountText})`, "g"), (_, tailsText, amount) => {
          tailsFromText(tailsText).forEach(tail => addNums(getTailNumbers(tail), cnNum(amount), market));
          matched = true;
          return ",";
        });
        const handlers = [
          new RegExp(`\\[([^\\]]+)\\]各?(${amountText})`, "g"),
          new RegExp(`(${numListText})(?:各|各号|各数|个|每个数|每号|一个数)(${amountText})`, "g"),
          new RegExp(`(${numListText})/(${amountText})`, "g")
        ];
        handlers.forEach(reg => {
          rest = rest.replace(reg, (_, numsText, amount) => {
            addNums(numsFromText(numsText), cnNum(amount), market);
            matched = true;
            return ",";
          });
        });

        rest = rest.replace(new RegExp(`平(${tailListWithTailText})(?:各|各号|各数|每个数|每号|一个数)?(${amountText})`, "g"), (_, tailsText, amount) => {
          tailsFromText(tailsText).forEach(tail => addWsBet(tail, cnNum(amount), market));
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`平(${tailText})尾(${amountText})`, "g"), (_, tail, amount) => {
          addWsBet(tail, cnNum(amount), market);
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`平尾(${tailText})(${amountText})`, "g"), (_, tail, amount) => {
          addWsBet(tail, cnNum(amount), market);
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`(${tailText})尾平(${amountText})`, "g"), (_, tail, amount) => {
          addWsBet(tail, cnNum(amount), market);
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`(${tailText})平尾(${amountText})`, "g"), (_, tail, amount) => {
          addWsBet(tail, cnNum(amount), market);
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`((?:野兽?|家禽?)肖?)(?:各肖|各)(${amountText})`, "g"), (_, name, amount) => {
          getAnimalGroupItems(name).forEach(item => addAnimalBet(item.name, amount, "各肖", market));
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`((?:野兽?|家禽?)肖?)(?:各号|各数|每号|每个数)(${amountText})`, "g"), (_, name, amount) => {
          addNums(getAnimalGroupNumbers(name), cnNum(amount), market);
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`(双数特|单数特|双特|单特|特双|特单|[红绿蓝兰]波?[单双]?)(包|各号|各数|各)?(${amountText})`, "g"), (_, name, marker, amount) => {
          if (addOtherBet(name, amount, marker, market)) {
            matched = true;
            return ",";
          }
          return _;
        });
        rest = rest.replace(new RegExp(`([${animalNames}]+)包特(${amountText})`, "g"), (_, names, amount) => {
          names.split("").forEach(name => addAnimalBet(name, amount, "各肖", market));
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`([${animalNames}]+)平特(?:各|各肖|各数)?(${amountText})`, "g"), (_, names, amount) => {
          names.split("").forEach(name => {
            addSxBet(name, cnNum(amount), market);
            addAnimalSplitBet(name, amount, market);
          });
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`一肖([${animalNames}]+)(${amountText})`, "g"), (_, names, amount) => {
          names.split("").forEach(name => addSxBet(name, cnNum(amount), market));
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`([${animalNames}]+)平(?:肖)?(?:各|各肖|各数)?(${amountText})`, "g"), (_, names, amount) => {
          names.split("").forEach(name => addSxBet(name, cnNum(amount), market));
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`平[^${animalNames}\\d.]*([${animalNames}]+)(?:各|各肖|各数)?(${amountText})`, "g"), (_, names, amount) => {
          names.split("").forEach(name => addSxBet(name, cnNum(amount), market));
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`(\\d{1,2})${listSep}*号(${amountText})`, "g"), (_, num, amount) => {
          addNum(num, cnNum(amount), market);
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`(\\d{1,2})\\.(${amountText})(?=斤|米|元|#|$)`, "g"), (_, num, amount) => {
          addNum(num, cnNum(amount), market);
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`特${tailSep}*(${tailListWithTailText})(?:各|各号|各数|每个数|每号|一个数)?(${amountText})`, "g"), (_, tailsText, amount) => {
          tailsFromText(tailsText).forEach(tail => addNums(getTailNumbers(tail), cnNum(amount), market));
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`(${tailListWithTailText})特?(?:各|各号|各数|每个数|每号|一个数)?(${amountText})`, "g"), (_, tailsText, amount) => {
          tailsFromText(tailsText).forEach(tail => addNums(getTailNumbers(tail), cnNum(amount), market));
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`(${numListText})头(?:各|各号|各数|每个数|每号|一个数)?(${amountText})`, "g"), (_, heads, amount) => {
          headsFromText(heads).forEach(head => addNums(getHeadNumbers(head), cnNum(amount), market));
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`(${numListText})特(?:各|各号|各数|每个数|每号|一个数)?(${amountText})`, "g"), (_, numsText, amount) => {
          addNums(numsFromText(numsText), cnNum(amount), market);
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`(\\d{1,2})特(${amountText})`, "g"), (_, num, amount) => {
          addNum(num, cnNum(amount), market);
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`(${animalListText}|[${animalNames}]+)${listSep}*特肖(?:各包|包|各肖|各)?(${amountText})`, "g"), (_, namesText, amount) => {
          animalsFromText(namesText).forEach(name => addAnimalBet(name, amount, "各肖", market));
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`(${animalListText}|[${animalNames}]+)${listSep}*特(各包|包|各肖|各号|各数|各)?(${amountText})`, "g"), (_, namesText, marker, amount) => {
          const betMarker = marker === "各肖" || marker === "各" || marker === "包" || marker === "各包" ? "各肖" : marker || "";
          animalsFromText(namesText).forEach(name => addAnimalBet(name, amount, betMarker, market));
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`(${animalListText}|[${animalNames}]+)${listSep}*(?:各号|各数)(${amountText})`, "g"), (_, namesText, amount) => {
          animalsFromText(namesText).forEach(name => addAnimalBet(name, amount, "各", market));
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`(${animalListText}|[${animalNames}]+)${listSep}*(?:各包|各肖|各)(${amountText})`, "g"), (_, namesText, amount) => {
          animalsFromText(namesText).forEach(name => addAnimalBet(name, amount, "各肖", market));
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`([${animalNames}]+)(各包|各肖|各数|各|包|每个数|每号|一个数|一粒)?(${amountText})`, "g"), (_, names, marker, amount) => {
          names.split("").forEach(name => addAnimalBet(name, amount, marker, market));
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`(平特肖|三连肖|平特)?([${animalNames}]+)(${amountText})`, "g"), (_, prefix, names, amount) => {
          names.split("").forEach(name => addAnimalBet(name, amount, prefix, market));
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`(平特肖|三连肖|平特)?([${animalNames}]+)/(${amountText})`, "g"), (_, prefix, names, amount) => {
          names.split("").forEach(name => addAnimalBet(name, amount, prefix, market));
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`([红绿蓝兰特大小单双]+)/(${amountText})`, "g"), (_, name, amount) => {
          if (addOtherBet(name, amount, "", market)) {
            matched = true;
            return ",";
          }
          return _;
        });
        rest = rest.replace(new RegExp(`([红绿蓝兰特大小单双]+)(?:各)?(${amountText})`, "g"), (_, name, amount) => {
          if (addOtherBet(name, amount, "", market)) {
            matched = true;
            return ",";
          }
          return _;
        });
        rest = rest.replace(new RegExp(`([${animalNames}])[.=](${amountText})`, "g"), (_, name, amount) => {
          addAnimalBet(name, amount, "各肖", market);
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`(\\d{1,2})[.=](${amountText})`, "g"), (_, num, amount) => {
          addNum(num, cnNum(amount), market);
          matched = true;
          return ",";
        });
        rest = rest.replace(new RegExp(`(\\d{1,2})(${amountText})`, "g"), (_, num, amount) => {
          addNum(num, cnNum(amount), market);
          matched = true;
          return ",";
        });

        const dirty = rest.replace(/[,\s#，。]/g, "");
        if (!matched && dirty) unmatched.push(line);
      });

      const numbers = Object.keys(numberMap)
        .map(key => numberMap[key])
        .sort((a, b) => Number(a.num) - Number(b.num));
      numbers.forEach(item => {
        item.sx = getNumberSxName(item.num, this.currentYear);
      });
      const sxBets = Object.keys(sxBetMap)
        .map(key => sxBetMap[key])
        .sort((a, b) => a.index - b.index);
      const wsBets = Object.keys(wsBetMap)
        .map(key => wsBetMap[key])
        .sort((a, b) => a.tail - b.tail);
      return {
        numbers,
        total: numbers.reduce((sum, item) => sum + item.count, 0),
        sxBets,
        sxTotal: sxBets.reduce((sum, item) => sum + item.count, 0),
        wsBets,
        wsTotal: wsBets.reduce((sum, item) => sum + item.count, 0),
        markets,
        unmatched
      };
    },
    async onSubmitParse() {
      if (!this.aiParsed || (!this.aiParsed.numbers.length && !this.aiParsed.sxBets.length && !this.aiParsed.wsBets.length)) {
        this.$message.warning("请先检测出内容");
        return;
      }
      const record = {
        id: Date.now(),
        time: new Date().toLocaleTimeString(),
        createdAt: new Date().toISOString(),
        txt: this.aiTxt.trim(),
        total: this.aiParsed.total + this.aiParsed.sxTotal + this.aiParsed.wsTotal,
        numbers: this.aiParsed.numbers.map(item => ({
          num: item.num,
          count: item.count,
          market: item.market
        })),
        sxBets: this.aiParsed.sxBets.map(item => ({
          name: item.name,
          count: item.count,
          index: item.index,
          market: item.market
        })),
        wsBets: this.aiParsed.wsBets.map(item => ({
          name: item.name,
          tail: item.tail,
          count: item.count,
          market: item.market
        }))
      };
      const changes = this.getParsedChanges(record.numbers, 1);
      const sxChanges = this.getParsedSxChanges(record.sxBets, 1);
      const wsChanges = this.getParsedWsChanges(record.wsBets, 1);
      if (!changes.length && !sxChanges.length && !wsChanges.length) {
        this.$message.warning("没有可提交的内容");
        return;
      }
      await this.submitParsedChanges(AI_BATCH_SUBMIT_API, record, changes, 1);
      await this.submitParsedSxChanges(sxChanges);
      await this.submitParsedWsChanges(wsChanges);
      this.applyParsedChanges(changes);
      this.applyParsedSxChanges(sxChanges);
      this.applyParsedWsChanges(wsChanges);
      this.aiSubmitHistory.unshift(record);
      this.saveAiSubmitHistory();
      this.$message.success("提交成功");
      this.aiTxt = "";
      this.aiResult = [];
      this.aiSxResult = [];
      this.aiWsResult = [];
      this.aiParsed = null;
    },
    onRemoveAiResult(index) {
      if (!this.aiParsed) return;
      this.aiResult.splice(index, 1);
      this.aiParsed.numbers = this.aiResult;
      this.aiParsed.total = this.aiResult.reduce((sum, item) => {
        return sum + (Number(item.count) || 0);
      }, 0);
    },
    onRemoveAiSxResult(index) {
      if (!this.aiParsed) return;
      this.aiSxResult.splice(index, 1);
      this.aiParsed.sxBets = this.aiSxResult;
      this.aiParsed.sxTotal = this.aiSxResult.reduce((sum, item) => {
        return sum + (Number(item.count) || 0);
      }, 0);
    },
    onRemoveAiWsResult(index) {
      if (!this.aiParsed) return;
      this.aiWsResult.splice(index, 1);
      this.aiParsed.wsBets = this.aiWsResult;
      this.aiParsed.wsTotal = this.aiWsResult.reduce((sum, item) => {
        return sum + (Number(item.count) || 0);
      }, 0);
    },
    onUndoParse(index) {
      const record = this.aiSubmitHistory[index];
      if (!record) return;
      const undoText = record.txt || record.text || "";
      const message = this.$createElement("div", { style: "max-width: 520px;" }, [
        this.$createElement("p", { style: "margin: 0 0 8px;" }, "是否撤销这次检测提交？"),
        this.$createElement("pre", {
          style: "max-height: 240px; overflow: auto; margin: 0; padding: 8px; background: #f5f7fa; border: 1px solid #dcdfe6; border-radius: 4px; white-space: pre-wrap; word-break: break-all; color: #303133;"
        }, undoText || "未保存提交文案")
      ]);
      this.$confirm(message, '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '撤销',
        cancelButtonText: '放弃'
      })
        .then(async () => {
          const changes = this.getParsedChanges(record.numbers, -1);
          const sxChanges = this.getParsedSxChanges(record.sxBets || [], -1);
          const wsChanges = this.getParsedWsChanges(record.wsBets || [], -1);
          if (!changes.length && !sxChanges.length && !wsChanges.length) {
            this.aiSubmitHistory.splice(index, 1);
            this.saveAiSubmitHistory();
            this.$message.warning("没有可撤销的内容");
            return;
          }
          await this.submitParsedChanges(AI_BATCH_UNDO_API, record, changes, -1);
          await this.submitParsedSxChanges(sxChanges);
          await this.submitParsedWsChanges(wsChanges);
          this.applyParsedChanges(changes);
          this.applyParsedSxChanges(sxChanges);
          this.applyParsedWsChanges(wsChanges);
          this.aiSubmitHistory.splice(index, 1);
          this.saveAiSubmitHistory();
          this.$message.success("撤销成功");
        })
        .catch(action => {

        });
    },
    getAiHistoryKey() {
      const user = this.user && this.user.username ? this.user.username : "default";
      const look = this.lookUser && this.lookUser.id ? this.lookUser.id : "self";
      return `${AI_HISTORY_KEY}_${user}_${look}`;
    },
    loadAiSubmitHistory() {
      try {
        const value = localStorage.getItem(this.getAiHistoryKey());
        this.aiSubmitHistory = value ? JSON.parse(value) : [];
      } catch (e) {
        this.aiSubmitHistory = [];
      }
    },
    saveAiSubmitHistory() {
      localStorage.setItem(this.getAiHistoryKey(), JSON.stringify(this.aiSubmitHistory.slice(0, 30)));
    },
    clearAiSubmitHistory() {
      localStorage.removeItem(this.getAiHistoryKey());
      this.aiSubmitHistory = [];
    },
    onClearAiSubmitHistory() {
      this.$confirm('是否清空本地提交记录？不会撤销已提交金额。', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '清空',
        cancelButtonText: '放弃'
      })
        .then(() => {
          this.clearAiSubmitHistory();
          this.$message.success("记录已清空");
        })
        .catch(action => {

        });
    },
    getParsedChanges(items, direction) {
      const changes = [];
      items.forEach(item => {
        const position = this.getNumPosition(item.num);
        if (!position) return;

        const numItem = this.nums[position.index][position.iindex];
        const current = Number(numItem.total) || 0;
        const delta = Number(item.count) * direction;
        const next = Math.max(0, current + delta);
        changes.push({
          num: parseInt(numItem.title),
          count: Number(item.count),
          delta: next - current,
          value: next,
          market: item.market,
          index: position.index,
          iindex: position.iindex
        });
      });
      return changes;
    },
    getParsedSxChanges(items, direction) {
      const changes = [];
      items.forEach(item => {
        const sxIndex = this.sx.findIndex(sitem => sitem.name === item.name);
        if (sxIndex === -1) return;
        const current = Number(this.sx[sxIndex].value) || 0;
        const delta = Number(item.count) * direction;
        changes.push({
          name: item.name,
          type: sxIndex + 1,
          index: sxIndex,
          count: Number(item.count),
          delta,
          value: Math.max(0, current + delta),
          market: item.market
        });
      });
      return changes;
    },
    getParsedWsChanges(items, direction) {
      const changes = [];
      items.forEach(item => {
        const tail = parseInt(item.tail, 10);
        if (tail < 0 || tail > 9) return;
        const current = Number(this.ws[tail].value) || 0;
        const delta = Number(item.count) * direction;
        changes.push({
          name: `${tail}尾`,
          tail,
          type: tail + 13,
          count: Number(item.count),
          delta,
          value: Math.max(0, current + delta),
          market: item.market
        });
      });
      return changes;
    },
    getNumPosition(numValue) {
      const num = parseInt(numValue, 10);
      if (!num || num < 1 || num > 49) return null;
      const index = Math.ceil(num / 10) - 1;
      let iindex = num % 10 - 1;
      if (iindex < 0) {
        iindex = 9;
      }
      if (!this.nums[index] || !this.nums[index][iindex]) return null;
      return { index, iindex };
    },
    applyParsedChanges(changes) {
      let totalDiff = 0;
      changes.forEach(change => {
        const numItem = this.nums[change.index][change.iindex];
        numItem.total = change.value;
        this.$set(this.nums[change.index], change.iindex, numItem);
        totalDiff += change.delta;
      });
      this.totalPrice = Math.max(0, this.totalPrice + totalDiff);
      this.averagePrice = parseInt(this.totalPrice / this.average);
    },
    applyParsedSxChanges(changes) {
      changes.forEach(change => {
        const item = this.sx[change.index];
        item.value = change.value;
        this.$set(this.sx, change.index, item);
      });
    },
    applyParsedWsChanges(changes) {
      changes.forEach(change => {
        const item = this.ws[change.tail];
        item.value = change.value;
        this.$set(this.ws, change.tail, item);
      });
    },
    submitParsedBatch(api, record, changes, direction) {
      const params = {
        id: record.id,
        direction,
        total: record.total,
        numbers: record.numbers,
        items: changes.map(item => ({
          num: item.num,
          count: item.count,
          delta: item.delta,
          value: item.value,
          market: item.market
        }))
      };
      return this.$http.post(api, params);
    },
    submitParsedChanges(api, record, changes, direction) {
      if (USE_AI_BATCH_API) {
        return this.submitParsedBatch(api, record, changes, direction);
      }
      const requests = changes.map(item => {
        return this.$http.post("/admin/xzt/edit", {
          num: parseInt(item.num),
          value: Number(item.value)
        });
      });
      return Promise.all(requests);
    },
    submitParsedSxChanges(changes) {
      const requests = changes.map(item => {
        return this.$http.post("/admin/xzt/addstatics", {
          type: parseInt(item.type),
          value: Number(item.delta)
        });
      });
      return Promise.all(requests);
    },
    submitParsedWsChanges(changes) {
      const requests = changes.map(item => {
        return this.$http.post("/admin/xzt/addstatics", {
          type: parseInt(item.type),
          value: Number(item.delta)
        });
      });
      return Promise.all(requests);
    },
    chineseToNumber(str) {
      const map = {
        零: 0,
        一: 1,
        二: 2,
        两: 2,
        三: 3,
        四: 4,
        五: 5,
        六: 6,
        七: 7,
        八: 8,
        九: 9
      }

      if (/^\d+$/.test(str)) return Number(str)

      if (str === '十') return 10

      if (str.includes('百')) {
        const arr = str.split('百')
        const hundreds = map[arr[0]] || 1
        const tens = arr[1] ? this.chineseToNumber(arr[1]) : 0
        return hundreds * 100 + tens
      }

      if (str.includes('十')) {
        const arr = str.split('十')

        const tens = arr[0] ? map[arr[0]] : 1
        const ones = arr[1] ? map[arr[1]] : 0

        return tens * 10 + ones
      }
      return map[str] || 0
    },
    addNum(map, num, count) {
      num = num.padStart(2, '0')

      map[num] = (map[num] || 0) + count
    },
    onBafa() {
      this.$router.push({ path: "/statics" });
    },
    onSelectUser(value) {
      this.$refs.addUser.show(value)
    },
    onLookUser(value) {
      this.lookUser = value;
      this.loadAiSubmitHistory();
      this.init();
    },
    addUser() {
      // this.$refs["add-user"].show();
      this.$refs["userList"].show();
    },
    init() {
      this.nums = [];
      this.totalPrice = 0;
      this.averagePrice = 0;
      this.ws = [
        { name: "0尾", value: 0 },
        { name: "1尾", value: 0 },
        { name: "2尾", value: 0 },
        { name: "3尾", value: 0 },
        { name: "4尾", value: 0 },
        { name: "5尾", value: 0 },
        { name: "6尾", value: 0 },
        { name: "7尾", value: 0 },
        { name: "8尾", value: 0 },
        { name: "9尾", value: 0 }];
      this.sx = [
        {
          name: "鼠",
          index: 0,
          selected: false,
          value: 0,
          isjq: false,
          values: []
        },
        {
          name: "牛",
          index: 0,
          selected: false,
          value: 0,
          isjq: true,
          values: []
        },
        {
          name: "虎",
          index: 0,
          selected: false,
          value: 0,
          isjq: false,
          values: []
        },
        {
          name: "兔",
          index: 0,
          selected: false,
          value: 0,
          isjq: false,
          values: []
        },
        {
          name: "龙",
          index: 0,
          selected: false,
          value: 0,
          isjq: false,
          values: []
        },
        {
          name: "蛇",
          index: 0,
          selected: false,
          value: 0,
          isjq: false,
          values: []
        },
        {
          name: "马",
          index: 0,
          selected: false,
          value: 0,
          isjq: true,
          values: []
        },
        {
          name: "羊",
          index: 0,
          selected: false,
          value: 0,
          isjq: true,
          values: []
        },
        {
          name: "猴",
          index: 0,
          selected: false,
          value: 0,
          isjq: false,
          values: []
        },
        {
          name: "鸡",
          index: 0,
          selected: false,
          value: 0,
          isjq: true,
          values: []
        },
        {
          name: "狗",
          index: 0,
          selected: false,
          value: 0,
          isjq: true,
          values: []
        },
        {
          name: "猪",
          index: 0,
          selected: false,
          value: 0,
          isjq: true,
          values: []
        },];

      const queryYear = parseInt(this.$route.query.year);
      const isTestYear = queryYear || this.currentYearFromLogin || this.currentYear !== new Date().getFullYear();
      if (queryYear) {
        this.currentYear = queryYear;
      }
      this.setSx();

      let lookid = "";
      if (this.lookUser) {
        lookid = this.lookUser.id;
      }
      const loadData = () => {
        this.$http.get("/admin/xzt/index", { look: lookid }).then(res => {
        let data = res.data;
        let maps = [];
        data.forEach(item => {
          maps[item.num] = item.value;
          this.totalPrice = this.totalPrice + (Number(item.value) || 0);
        })

        this.averagePrice = parseInt(this.totalPrice / this.average);
        this.nums = getNumbers(maps, this.currentYear);
        this.$http.get("/admin/xzt/statics", { look: lookid }).then(res => {
          console.log("statics:", res);
          let data = res.data;
          data.forEach(item => {
            var type = parseInt(item.type);
            if (type < 13) {
              this.sx[type - 1].value = item.value;
            } else if (type >= 13 && type < 24) {
              this.ws[type - 13].value = item.value;
            }
          })
        })
      })
      };
      if (isTestYear) {
        loadData();
        return;
      }
      this.$http.get("/admin/xzt/lunar").then(res => {
        if (res.data) {
          this.currentYear = parseInt(res.data);
          this.setSx();
        }
        loadData();
      });
    },
    setSx() {
      const sxList = getSxListByYear(this.currentYear);
      this.sx = this.sx.map(item => {
        const sxItem = sxList.find(sitem => sitem.name === item.name);
        return Object.assign({}, item, {
          index: sxItem.index,
          values: sxItem.values
        });
      });
    },

    onClearAll() {
      let self = this;
      this.$confirm('是否确认清除所有信息？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '清除',
        cancelButtonText: '放弃'
      })
        .then(() => {
          self.$http.get("/admin/xzt/clearall").then(res => {
            self.$message.success("清除成功");
            self.clearAiSubmitHistory();
            self.totalPrice = 0;
            self.averagePrice = 0;
            self.init();
          });
        })
        .catch(action => {

        });
    },
    onClear() {
      let self = this;
      this.$confirm('是否确认清除此次所有信息？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '清除',
        cancelButtonText: '放弃'
      })
        .then(() => {
          self.$http.get("/admin/xzt/clear").then(res => {
            self.$message.success("清除成功");
            self.clearAiSubmitHistory();
            self.totalPrice = 0;
            self.averagePrice = 0;
            self.init();
          });
        })
        .catch(action => {

        });

    },
    onNum(index, value) {
      if (this.nindex == index) {
        this.nindex = -1;
        this.sx_money = "";
        return;
      }
      this.nindex = index;
      this.sx_money = value + "";
    },
    onOther(index) {
      if (this.ooindex == index) {
        this.ooindex = -1;
        if (index == 7) {
          for (var s = 0; s < this.sx.length; s++) {
            let sitem = this.sx[s];
            if (sitem.isjq == true) {
              this.onSXitem(s);
            }
          }
        }
        if (index == 8) {
          for (var s = 0; s < this.sx.length; s++) {
            let sitem = this.sx[s];
            if (sitem.isjq == false) {
              this.onSXitem(s);
            }
          }
        }
      } else {
        this.ooindex = index;
      }
      if (index < 7) {
        for (var s = 0; s < this.sx.length; s++) {
          let sitem = this.sx[s];
          this.onSXitemOther(s, false);
        }
      }

      var a = arr[index];
      for (var i = 0; i < this.nums.length; i++) {
        var nitems = this.nums[i];
        for (var j = 0; j < nitems.length; j++) {
          var item = this.nums[i][j];
          if (this.ooindex == -1) {
            item.selected = false;
          } else {

            if (index < 2) {
              if (item.title % 2 == a) {
                item.selected = true;
              } else {
                item.selected = false;
              }
            } else if (index > 1 && index < 5) {
              if (item.color == a) {
                item.selected = true;
              } else {
                item.selected = false;
              }
            } else if (index == 6) { //小
              if (parseInt(item.title) < 25) {
                item.selected = true;
              } else {
                item.selected = false;
              }
            } else if (index == 5) {//大
              if (parseInt(item.title) > 24) {
                item.selected = true;
              } else {
                item.selected = false;
              }
            } else if (index == 7) {//家禽
              for (var s = 0; s < this.sx.length; s++) {
                let sitem = this.sx[s];
                if (sitem.isjq == true) {
                  this.onSXitemOther(s, true);
                } else {
                  this.onSXitemOther(s, false);
                }
              }
            } else if (index == 8) {//野兽
              for (var s = 0; s < this.sx.length; s++) {
                let sitem = this.sx[s];
                if (sitem.isjq == false) {
                  this.onSXitemOther(s, true);
                } else {
                  this.onSXitemOther(s, false);
                }
              }
            }
          }

        }
      }
    },
    onSelectItem(index, nindex) {
      let selected = this.nums[nindex][index].selected;
      this.nums[nindex][index].selected = !selected;
    },
    onSXitemOther(value, selected) {
      let item = this.sx[value];
      this.sx[value].selected = selected;
      let sx = item.index;
      let isMax = sx > 1 ? 0 : 1;
      for (var i = 0; i < 4 + isMax; i++) {
        let num = sx + i * 12;
        let index = Math.ceil(num / 10) - 1;
        let iindex = num % 10 - 1;
        if (iindex < 0) {
          iindex = 9;
        }
        this.nums[index][iindex].selected = this.sx[value].selected;
      }
    },
    onSXitem(value) {
      //this.selectedSX = index;
      let item = this.sx[value];
      this.sx[value].selected = !item.selected;
      let sx = item.index;
      let isMax = sx > 1 ? 0 : 1;
      for (var i = 0; i < 4 + isMax; i++) {
        let num = sx + i * 12;
        let index = Math.ceil(num / 10) - 1;
        let iindex = num % 10 - 1;
        if (iindex < 0) {
          iindex = 9;
        }
        console.log("index:", index, "iindex:", iindex, "sx:", sx);
        this.nums[index][iindex].selected = this.sx[value].selected;
      }
    },
    onStatics() {
      this.$refs["s-list"].show(this.sx, this.ws);
    },
    onAll() {
      this.$router.push({
        path: '/all',
        query: {
          user: this.lookUser,
          year: this.currentYear
        }
      })
    },
    onSettlement() {
      let settlement = getMoney(
        this.nums,
        this.totalPrice,
        this.averagePrice,
        this.average
      );
      this.buyPrice = settlement.buy_price;
      console.log("averagePrice:", this.averagePrice, "total:", this.totalPrice, "average:", this.average);
      this.$refs["x-list"].show(settlement, this.totalPrice, this.averagePrice, this.user, this.currentYear);
    },
    onClearsx() {
      for (var i = 0; i < this.nums.length; i++) {
        let items = this.nums[i];
        for (var j = 0; j < items.length; j++) {
          let item = items[j];
          item.selected = false;
        }
      }

      for (var ii = 0; ii < this.sx.length; ii++) {
        let item = this.sx[ii];
        item.selected = false;
      }
      this.sx_money = "";
    },
    onBuysx() {

      if (this.sx_money == "") return;
      for (var i = 0; i < this.nums.length; i++) {
        let items = this.nums[i];
        for (var j = 0; j < items.length; j++) {
          let item = items[j];
          if (item.selected) {
            this.onBuy(this.sx_money, i, j);
          }
        }
      }
      this.onClearsx();
    },
    onBuysx_old() {
      if (this.selectedSX > -1) {
        // console.log("money:", this.sx_money,'index:',this.selectedSX);
        let isMax = (this.selectedSX) > 0 ? 0 : 1;
        let sx = this.selectedSX + 1;
        console.log("index:", sx);
        for (var i = 0; i < 4 + isMax; i++) {
          let num = sx + i * 12;
          let index = Math.ceil(num / 10) - 1;
          let iindex = num % 10 - 1;
          this.onBuy(this.sx_money, index, iindex);
          console.log("num:", num, "index:", index, "iindex:", iindex);
        }

      }
    },
    onItemBuy(val, ii) {
      var index = parseInt(ii) + 1;
      console.log("val:", val, "index:", index);


      this.$http.post("/admin/xzt/addstatics", { type: parseInt(index), value: Number(val) }).then(res => {
        console.log("res:", res);
        let vv = Number(this.sx[ii].value) || 0;
        this.sx[ii].value = vv + Number(val);
      });
    },
    onItemBuyTwo(val, ii) {
      var index = parseInt(ii) + 13;
      console.log("val:", val);
      this.$http.post("/admin/xzt/addstatics", { type: parseInt(index), value: Number(val) }).then(res => {
        console.log("res:", res);
        let vv = Number(this.ws[ii].value) || 0;
        this.ws[ii].value = vv + Number(val);
      });
    },
    onBuy(val, index, iindex) {

      let value = Number(val);

      let item = this.nums[index][iindex];
      item.total = (Number(item.total) || 0) + value;
      this.totalCount += 1;
      this.nums[index][iindex] = item;

      console.log("num:", item.title, "value:", item.total);

      this.$http.post("/admin/xzt/edit", { num: parseInt(item.title), value: Number(item.total) }).then(res => {

        console.log("res:", res);
      });

      this.totalPrice = this.totalPrice + value;

      //   if(this.totalPrice>5000)//开始计算平均数
      //   {
      //       this.averagePrice = parseInt(this.totalPrice / 42.75);
      //   }

      this.averagePrice = parseInt(this.totalPrice / this.average);

      if (value > this.maxPrice) {
        this.maxPrice = value;
      }
      if (this.minPrice == 0) {
        this.minPrice = value;
      } else if (value < this.minPrice) {
        this.minPrice = value;
      }
    },
  },
};
</script>
<style lang="less" scoped>
#xzt {
  font-size: 12px;
  color: black;
  min-width: 1400px;

  .clearfix:after {
    visibility: hidden;
    display: block;
    font-size: 0;
    content: " ";
    clear: both;
    height: 0;
  }

    .user-logout {
      margin-left: 8px;
      vertical-align: middle;
    }
  .header {
    height: 40px;
    width: 100%;
    background-image: linear-gradient(to right, #0f6ad7, #00ced4);
    padding: 0px 30px;
    box-sizing: border-box;
    color: white;
    font-size: 20px;
    text-align: left;
    display: flex;
    line-height: 40px;

    .el-button {
      padding: 5px 10px;
      font-size: 12px;

    }

    .header-left {
      flex: 1;

      span {
        margin-right: 30px;
      }
    }

    .header-right {
      flex: none;

      .el-button {
        padding: 5px 30px;
        font-size: 18px;
      }
    }
  }

  .footer {
    height: 50px;
  }

  .content {
    min-width: 1400px;
    margin: 0 auto;
    width: 100%;
    padding-left: 10px;
    box-sizing: border-box;

    .content-left {
      width: calc(25% - 20px);
      margin-top: 5px;
      float: left;
      height: 600px;

      .sxs {
        margin-top: 10px;

        .sxs-item {
          width: 16.6%;
          float: left;
          cursor: pointer;
          line-height: 30px;
          // border:1px solid #ddd;
          box-sizing: border-box;
          font-size: 15px;
          font-weight: bold;

          &.active {
            background: #ddd;
          }
        }
      }

      .nums-bottom {
        width: 100%;
        margin-top: 10px;

        .num {
          width: 19%;
          cursor: pointer;
          float: left;
          font-size: 16px;
          font-weight: bold;
          height: 40px;
          line-height: 40px;
          border: 1px solid #ddd;
          color: black;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;

          &.active {
            background: red;
            color: white;
          }
        }
      }

      .others {
        margin-top: 10px;

        .other {
          float: left;
          width: 20%;
          box-sizing: border-box;
          height: 40px;
          border: 1px solid #ddd;
          line-height: 40px;
          font-size: 14px;
          color: red;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;

          &.active {
            background: red;
            color: white;
          }

          &.black {
            color: black;
          }

          &.red {
            color: red;
          }

          &.blue {
            color: rgb(118, 118, 242);
          }

          &.green {
            color: rgb(64, 209, 64);
          }
        }
      }

      .tools {
        display: flex;
        flex-direction: row;
        margin-top: 10px;

        span {
          width: 50px;
          line-height: 40px;
        }

        .el-button {
          padding: 10px 20px;
          margin-left: 5px;
          box-sizing: border-box;
        }

        .el-input {
          width: 100px;
        }
      }

      .nums {
        .nums-title {
          background: red;
          line-height: 30px;
          font-size: 20px;
        }

        .nums-rows {
          .num-row {
            width: 20%;
            float: left;

            .nums-item {
              border: 1px solid #ddd;
              box-sizing: border-box;
              height: 40px;
              line-height: 40px;
              font-size: 15px;
              font-weight: bold;

              p {
                &.red {
                  color: red;
                }

                &.blue {
                  color: rgb(118, 118, 242);
                }

                &.green {
                  color: rgb(64, 209, 64);
                }
              }

              &.active {
                background: yellow;
              }
            }
          }
        }
      }
    }

    .sx-content-new {
      width: 20%;
      float: left;
      margin-left: 5px;
      margin-top: 5px;

      .title {
        line-height: 30px;
        background: green;
        font-size: 20px;
        color: white;
      }

      .item {
        width: 100%;
        background: green;
        margin-top: 5px;
        text-align: left;
        padding: 5px;
        line-height: 47px;
        max-height: 57px;
        font-size: 26px;
        color: white;
        box-sizing: border-box;
        display: flex;
        padding-left: 10px;

        .title {
          width: 50px;
          font-size: 30px;
          text-align: center;
          line-height: 44px;
          font-weight: bold;
        }

        .content {
          flex: 1;
        }

        label {
          margin-left: 10px;
          line-height: 47px;

        }
      }
    }

    .sx-content {
      width: 15%;
      float: left;
      margin-left: 5px;
      margin-top: 5px;

      .title {
        line-height: 30px;
        background: #0f6ad7;
        font-size: 20px;
        color: white;
      }

      .sx-item {
        width: 100%;
        background: #0f6ad7;
        margin-top: 5px;
        text-align: left;
        padding: 5px;
        box-sizing: border-box;
      }
    }

    .ws-content {
      width: 15%;
      height: 500px;
      margin-left: 5px;
      margin-top: 5px;
      float: left;

      .title {
        color: white;
        line-height: 30px;
        background: olive;
        font-size: 20px;
      }

      .ws-item {
        width: 100%;
        background: olive;
        margin-top: 5px;
        text-align: left;
        padding: 5px;
        box-sizing: border-box;
      }
    }

    .ai-content {
      width: calc(25% - 10px);
      min-height: 500px;
      background: white;
      float: left;
      margin-left: 5px;
      margin-top: 5px;

      textarea {
        width: 100%;
        resize: none;
        line-height: 20px;
      }

      .btns {
        align-items: flex-end;
        justify-content: end;
        display: flex;
        flex-direction: row;
        padding-right: 10px;
        padding-top: 10px;
        box-sizing: border-box;
        width: 100%;

        .el-button {
          padding: 10px 15px;
        }
      }
      .aiResult{
        width: 100%;
        .summary,
        .history-title{
          text-align: left;
          padding: 8px 10px;
          border-bottom: 1px solid #ddd;
          font-weight: bold;
          box-sizing: border-box;
        }
        .history-title{
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .preview{
          padding: 8px 10px;
          text-align: left;
          border-bottom: 1px solid #ddd;
          box-sizing: border-box;
          .tag{
            display: inline-block;
            position: relative;
            margin: 0 6px 6px 0;
            padding: 2px 16px 2px 6px;
            line-height: 20px;
            background: #f5f7fa;
            border: 1px solid #dcdfe6;
            border-radius: 4px;
            .remove{
              position: absolute;
              top: -6px;
              right: -5px;
              width: 16px;
              height: 16px;
              padding: 0;
              border: 1px solid #f56c6c;
              border-radius: 50%;
              background: white;
              color: #f56c6c;
              line-height: 14px;
              font-size: 12px;
              cursor: pointer;
            }
            .sx-name{
              display: inline-block;
              min-width: 18px;
              color: #303133;
              font-weight: bold;
              margin-right: 4px;
            }
            .num{
              color: #0f6ad7;
              font-weight: bold;
              margin-right: 4px;
            }
            .count{
              color: #f56c6c;
              font-weight: bold;
            }
            .count:before{
              content: ":";
              color: #909399;
              margin-right: 2px;
            }
            .market{
              color: #67c23a;
              margin-left: 4px;
            }
          }
        }
        .history-item{
          display: flex;
          width: 100%;
          align-items: flex-start;
          gap: 8px;
          border-bottom: 1px solid #ddd;
          padding: 8px 10px;
          box-sizing: border-box;
          text-align: left;
          line-height: 20px;
          .history-info{
            flex: 1;
            min-width: 0;
            p{
              margin: 0;
              word-break: break-all;
            }
            pre{
              margin: 4px 0 0;
              max-height: 54px;
              overflow: hidden;
              white-space: pre-wrap;
              word-break: break-all;
              color: #606266;
              font-size: 12px;
              line-height: 18px;
            }
          }
          .el-button{
            padding: 5px 10px;
            flex: none;
          }
        }
      }
    }

    .grid-content {
      width: 14%;
      float: left;

      .item {
        width: calc(100% - 20px);
        background: #0f6ad7;
        margin-top: 5px;
        margin-right: 10px;
        margin-left: 10px;
        text-align: left;
        padding: 5px;
        box-sizing: border-box;

        &.red {
          background: red;
        }

        &.blue {
          background: rgb(118, 118, 242);
        }

        &.green {
          background: rgb(64, 209, 64);
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .clearfix:after {
      visibility: hidden;
      display: block;
      font-size: 0;
      height: auto;
    }

      .user-logout {
      margin-left: 8px;
      vertical-align: middle;
    }
  .header {
      display: block;
      height: auto;
    }

    .content {
      width: 100%;

      .content-left {
        width: 100%;
        height: auto;

        .sxs {
          width: 100%;

        }

        .others {
          width: 100%;
        }
      }

      .sx-content {
        width: 50%;
        margin: 0;
      }

      .ws-content {
        width: 50%;
        margin: 0;
      }

      .sx-content-new {
        width: 100%;
        margin: 0;
      }
    }

  }
}
</style>
